import React from 'react';
import { BRAND } from '../lib/content';
export function Footer() {
  return <footer className="w-full border-t border-navy-50 bg-white pb-28 pt-14 lg:pb-14" data-id="element-161" data-mp="3gf96t1ka0gbl">
      <div className="mx-auto flex w-full max-w-4xl flex-col items-center gap-6 px-5 text-center sm:px-8" data-id="element-162" data-mp="3gh3sii3dgcgq">
        <h2 className="font-display text-2xl font-black text-navy" data-id="element-163" data-mp="36pftnw4hjt58">
          {BRAND.name}
        </h2>
        <p className="text-sm font-medium text-navy/60" data-id="element-164" data-mp="3ufa4671c15mb">
          Producto 100% digital. Recibís el acceso por email después de la compra.
        </p>
        <p className="mt-4 text-xs font-bold text-navy/40" data-id="element-165" data-mp="387ddgpep1cm">
          © {new Date().getFullYear()} {BRAND.name} · Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}